// import axios from 'axios'
import $ from 'jquery'
import { commonMixin } from '../scripts/commonMixin'

export const joiaMixin = {
    mixins: [commonMixin],
    data () {
        return {
            // baseUrlImg: 'http://localhost:8082/ADVICE_SERVER/',
            baseUrlImg: 'https://advice.domm.com.br:8445/ADVICE_SERVER/',
            // baseUrlApi: 'https://localhost:8443/AdviceServer/restapi/search/', // esse
            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/', // esse
            nome: 'joiaMixin',
            pedraIndex: 0,
            tipoIndex: 0,
            materialIndex: 0,
            categoriaIndex: 0,
            offsetLeft: [0, 0],
            showProducts: false,
            searchTextProd: '',
            productsFilter: [],
            productsFull: [
                {
                    titulo: 'ALIANÇA EM OURO',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 2850,
                    categoria: [1, 2, 4, 6],
                    material: [1],
                    tipo: [1],
                    pedra: [],
                    imgs: [
                        'alianca_ouro.jpg',
                        'p_ave_02.jpg',
                        'p_ave_03.jpg'
                    ]
                },
                {
                    titulo: 'BRINCO EM ESMERALDA',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 1500,
                    categoria: [1, 2],
                    material: [2],
                    tipo: [2],
                    pedra: [6],
                    imgs: [
                        'brinco_esmeralda.jpg',
                        'p_ave_cor_02.jpg'
                    ]
                },
                {
                    titulo: 'BRINCO EM OURO',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 2850,
                    categoria: [1, 2],
                    material: [1],
                    tipo: [2],
                    pedra: [],
                    imgs: [
                        'brinco_ouro.jpg'
                    ]
                },
                {
                    titulo: 'BRINCO EM OURO',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 1500,
                    categoria: [1, 2, 3],
                    material: [1],
                    tipo: [2],
                    pedra: [],
                    imgs: [
                        'brinco_ouro2.jpg',
                        'p_colar_02.jpg',
                        'p_colar_03.jpg'
                    ]
                },
                {
                    titulo: 'PULSEIRA EM OURO',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 1850,
                    categoria: [1, 2, 3],
                    material: [1],
                    tipo: [5],
                    pedra: [],
                    imgs: [
                        'pulseira_ouro.jpg',
                        'p_colar_aparador_02.jpg',
                        'p_colar_aparador_03.jpg'
                    ]
                },
                {
                    titulo: 'PULSEIRA EM PRATA',
                    desc: 'Meu produto bom e lega e agora essa descircoa é muti ogrande e legal, vamos ver se ela cabe aqui no teste aleatorio so para testear. cinc ocamaeroes empanado e um pedaco filie desse tamanho. 1',
                    preco: 1850,
                    categoria: [1, 2, 5],
                    material: [4],
                    tipo: [5],
                    pedra: [],
                    imgs: [
                        'pulseira_prata.jpg',
                        'p_colar_aparador_02.jpg',
                        'p_colar_aparador_03.jpg'
                    ]
                },
                {
                    titulo: 'RELOGIO ORIENTE',
                    desc: 'Imponente e marcante, nosso relógio Orient masculino dourado com pulseira em aço!',
                    preco: 1850,
                    categoria: [6, 2, 7],
                    material: [],
                    tipo: [5],
                    pedra: [],
                    imgs: [
                        'relogio_ouro.jpg'
                    ]
                }
            ]
        }
    },

    components: {
    },

    methods: {
        shiftSlide (divname, right, i) {
            var el = $('#' + divname)
            var el2 = document.getElementById(divname)
            var maxWidth = el2.scrollWidth
            var increStep = el2.clientWidth * (2.0 / 4.0)

            // console.log('shiftSlide::', divname, right)
            // console.log('shiftSlide::', maxWidth, increStep)

            if (right) {
                this.offsetLeft[i] -= increStep
                if (this.offsetLeft[i] < 0) {
                    this.offsetLeft[i] = 0
                }
            } else {
                this.offsetLeft[i] += increStep
                if (this.offsetLeft[i] > maxWidth) {
                    this.offsetLeft[i] = maxWidth
                }
            }
            el.animate({'scrollLeft': this.offsetLeft[i]}, 500)
        },
        generateProductsMat () {
            var prodsFilter = []

            for (let i = 0; i < this.productsFull.length; i++) {
                let prod = this.productsFull[i]
                // console.log('len: ', this.searchTextProd.length, this.minSearchLen)
                if (this.searchTextProd.length >= this.minSearchLen) {
                    if (prod.titulo.toLowerCase().indexOf(this.searchTextProd) >= 0 ||
                        prod.desc.toLowerCase().indexOf(this.searchTextProd) >= 0) {
                        // console.log('adding: ', prod.titulo)
                        prodsFilter.push(prod)
                    }
                } else if ((this.tipoIndex === 0 || (prod.tipo.includes(this.tipoIndex))) &&
                    (this.materialIndex === 0 || (prod.material.includes(this.materialIndex))) &&
                    (this.pedraIndex === 0 || (prod.pedra.includes(this.pedraIndex))) &&
                    (this.categoriaIndex === 0 || (prod.categoria.includes(this.categoriaIndex)))) {
                    prodsFilter.push(prod)
                }
            }

            return prodsFilter
        },
        generateProductsMatCat (categoriaIndex) {
            var prodsFilter = []

            for (let i = 0; i < this.productsFull.length; i++) {
                let prod = this.productsFull[i]
                if (prod.categoria.includes(categoriaIndex)) {
                    prodsFilter.push(prod)
                }
            }

            return prodsFilter
        },
        getComboBoxText (comboType) {
            switch (comboType) {
                case 0:
                    if (this.pedraIndex > 0) {
                        return this.pedras[this.pedraIndex - 1]
                    } else {
                        return 'Pedra'
                    }
                case 1:
                    if (this.tipoIndex > 0) {
                        return this.tipo[this.tipoIndex - 1]
                    } else {
                        return 'Tipo'
                    }
                case 2:
                    if (this.materialIndex > 0) {
                        return this.material[this.materialIndex - 1]
                    } else {
                        return 'Material'
                    }
                case 3:
                    if (this.categoriaIndex > 0) {
                        return this.cats_full[this.categoriaIndex - 1].nome
                    } else {
                        return 'Categoria'
                    }
            }
        },
        changePedra (event) {
            var text = event.target[event.target.selectedIndex].text
            console.log('changePedra:text: ', text)
            this.searchTextProd = ''
            this.productsFilter = this.generateProductsMat()
        },
        changeTipo (event) {
            var text = event.target[event.target.selectedIndex].text
            console.log('changeTipo:text: ', text)
            this.searchTextProd = ''
            this.productsFilter = this.generateProductsMat()
        },
        changeMaterial (event) {
            var text = event.target[event.target.selectedIndex].text
            console.log('changeTipo:text: ', text)
            this.searchTextProd = ''
            this.productsFilter = this.generateProductsMat()
        },
        refreshCategoriaIndex (index) {
            console.log('refreshCategoriaIndex:index: ', index)
            this.categoriaIndex = index
            this.searchTextProd = ''
            this.productsFilter = this.generateProductsMat()
            this.showProducts = true

            this.pedraIndex = 0
            this.tipoIndex = 0
            this.materialIndex = 0

            this.hideSideBar()
        },
        changeCategoria (event) {
            var text = event.target[event.target.selectedIndex].text
            console.log('changeCategoria:text: ', text)
            this.searchTextProd = ''
            this.productsFilter = this.generateProductsMat()
        },
        goToHome () {
            this.showProducts = false
        },
        getProductsSearch (text) {
            console.log('getProductsSearch: ' + text)
            this.searchTextProd = text
            this.showProducts = true

            this.pedraIndex = 0
            this.tipoIndex = 0
            this.materialIndex = 0
            this.categoriaIndex = 0

            this.productsFilter = this.generateProductsMat()
        },
        changeSideBar () {
            // console.log('entrei no changeSideBar');
            $('#icmenu').toggleClass('open')
            if (!$('#sidebar').hasClass('active')) {
                $('.overlay').fadeIn()
                $('.collapse.in').toggleClass('in')
                $('a[aria-expanded=true]').attr('aria-expanded', 'false')
                if ($('#sidebarCollapse').attr('class').includes('section_desk')) {
                    setTimeout(function () {
                        $('#sidebarCollapse').removeClass('section_desk')
                        $('#sidebarCollapse').addClass('section_desk_open')
                    }, 250)
                }
            } else {
                $('.overlay').fadeOut()

                if ($('#sidebarCollapse').attr('class').includes('section_desk')) {
                    setTimeout(function () {
                        $('#sidebarCollapse').addClass('section_desk')
                        $('#sidebarCollapse').removeClass('section_desk_open')
                    }, 250)
                }
            }
            $('#sidebar').toggleClass('active')
        },
        hideSideBar () {
            // remove a visibilidade da barra de menu lateral
            $('#sidebar').removeClass('active')
            $('.overlay').fadeOut()
            $('#icmenu').removeClass('open')
        }
    },

    created () {
        console.log('joiaMixin::created')
    },

    mounted () {
        console.log('joiaMixin::mounted')
    },

    beforeDestroy () {
    }
}



// WEBPACK FOOTER //
// ./src/scripts/joiaMixin.js